import { LinkedTagListCell } from "../../../components/molecules/Table/Cell";

export function PurchaseOrderShipmentsCell({ order, width = 100 }) {
  return (
    <LinkedTagListCell
      items={order?.shipments}
      getTo={shipment => `/shipment/po-to/${shipment.id}`}
      width={width}
    />
  );
}
